module.exports = __webpack_public_path__ + "img/album23_15.6a9def3d.jpg";